import React, { useEffect } from "react";
import styles from "./MisCotizacionesDeMateriales.module.scss";
import { connect } from "react-redux";
import { getMyQuotations, openSuscriptionModal, openMainModal, deleteQuotation } from "../../../../store/actions";
import { ReactComponent as MarketPlace } from "../../../../assets/svg/marketplace.svg";
import EmptyState from "../../../UI/EmptyState/EmptyState";
import { motion, AnimatePresence } from "framer-motion";
import PrivateQuotationItem from "../../../MainInfoItem/PrivateQuotationItem/PrivateQuotationItem";
import { useNavigate, useLocation } from "react-router-dom";
import { buildNavigationParams, getUserDisplayName } from "../../../../utils/navigationHelpers.ts";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";

const MisCotizacionesDeMateriales = ({ 
        isUserPremium, 
        getMyQuotations, 
        openSuscriptionModal, 
        openMainModal,
        deleteQuotation,
        cotizaciones,
        viewQuotationsLoading,
        userData,
        profileVisualizerData,
        myPerson, 
        setInfoReady
    }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const targetUserId = myPerson ? userData?.id : profileVisualizerData?.id;

    useEffect(() => {
        if (!targetUserId) return;
        getMyQuotations(targetUserId);
    }, [getMyQuotations, targetUserId]);

    const cotizacionesToMap = cotizaciones.filter(cotizacion => cotizacion.type === "PRIVATE");

    useEffect(() => {
        if (!viewQuotationsLoading && cotizaciones !== undefined) {
            setInfoReady(true);
        }
    }, [viewQuotationsLoading, cotizaciones, setInfoReady]);

    const handleNewMaterialBudget = () => {
        if (!isUserPremium) {
            openSuscriptionModal();
            return;
        }
        const isFromProfile = location.pathname.startsWith('/perfil/');
        if (isFromProfile && myPerson) {
            const userId = userData?.id ? String(userData.id) : null;
            const userName = getUserDisplayName(userData);
            if (userId && userName) {
                const params = buildNavigationParams('Cotización de materiales', userId, userName);
                navigate(`/cotizaciondemateriales/crear${params}`);
                return;
            }
        }
        navigate("/cotizaciondemateriales/crear");
    };

    const handleOpenQuotation = (quotation) => {
        if (!quotation) return;
        const isFromProfile = location.pathname.startsWith('/perfil/');
        const targetUser = myPerson ? userData : profileVisualizerData;
        const userId = targetUser?.id ? String(targetUser.id) : null;
        const userName = getUserDisplayName(targetUser);
        const params =
            isFromProfile && userId && userName
                ? buildNavigationParams('Cotización de materiales', userId, userName)
                : '';

        if (myPerson) {
            navigate(`/cotizaciondemateriales/${quotation.id}${params}`);
        } else {
            navigate(`/cotizaciondemateriales/postulante/${quotation.id}${params}`);
        }
    };

    const handleEditQuotation = (quotation) => {
        if (!quotation) return;
        const isFromProfile = location.pathname.startsWith('/perfil/');
        const targetUser = myPerson ? userData : profileVisualizerData;
        const userId = targetUser?.id ? String(targetUser.id) : null;
        const userName = getUserDisplayName(targetUser);
        if (isFromProfile && myPerson && userId && userName) {
            const params = buildNavigationParams('Cotización de materiales', userId, userName);
            navigate(`/cotizaciondemateriales/edit/${quotation.id}${params}`);
            return;
        }
        navigate(`/cotizaciondemateriales/edit/${quotation.id}`);
    };

    const handleDeleteQuotation = (quotation) => {
        if (!quotation) return;
        openMainModal({
            title: "¿Estás seguro de querer eliminar la cotización?",
            body: "Si la eliminas no podrás recuperarla.",
            iconType: "warning",
            isSuccess: false,
            confirmHandler: () => {
                const refreshAfterDelete = () => {
                    if (targetUserId) {
                        getMyQuotations(targetUserId);
                    }
                };
                deleteQuotation(quotation.id, refreshAfterDelete);
            }
        });
    };

    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={{ opacity: 0, y: 200 }}
                animate={{ opacity: 1, y: 0 }}
                className={styles.MisCotizaciones}>
                {viewQuotationsLoading ? (
                    <div className={styles.loadingContainer}>
                        <RegisteredUserProfileLoader />
                    </div>
                ) : (
                    cotizacionesToMap && cotizacionesToMap.length > 0 ? (
                        <div className={styles.container}>
                            {cotizacionesToMap.map((cotizacion) => (
                                <PrivateQuotationItem
                                    key={cotizacion.id}
                                    quotation={cotizacion}
                                    onManage={handleOpenQuotation}
                                    onEdit={handleEditQuotation}
                                    onDelete={handleDeleteQuotation}
                                    myPerson={myPerson}
                                />
                            ))}
                        </div>
                    ) : (
                        myPerson ? (
                        <div className={styles.emptyState} onClick={handleNewMaterialBudget}>
                            <EmptyState
                                title="No tienes cotizaciones de materiales ¡Crea una!"
                                icon={<MarketPlace width={50} height={50} />}
                            />
                        </div>
                        ) : (
                            <EmptyState
                                title="Este usuario no tiene cotizaciones de materiales"
                                icon={<MarketPlace width={50} height={50} />}
                            />
                        )
                    )
                )}
            </motion.div>
        </AnimatePresence>
    );
}

const mapStateToProps = (state) => ({
    cotizaciones: state.profile.viewQuotations,
    viewQuotationsLoading: state.profile.viewQuotationsLoading,
    userData: state.general.userData,
    isUserPremium: state.general.isUserPremium,
});

export default connect(mapStateToProps, { getMyQuotations, openSuscriptionModal, openMainModal, deleteQuotation })(MisCotizacionesDeMateriales);
